/* eslint tailwindcss/no-custom-classname: off */
import css from 'styled-jsx/css'
import { Check } from '../icon'
const styles = css`
  .fl-form-line {
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    padding: 2px 0;
    width: 100%;
    margin: -1px auto 0;
    display: table;
  }
  .fl-form {
    display: table-cell;
    width: 490px;
    padding: 20px;
  }
  .form-label {
    position: relative;
    display: table-cell;
    width: 230px;
    font-size: 17px;
    line-height: 1;
    background-color: #f4f4f4;
    padding: 20px;
    text-align: left;
  }
  .require:after {
    display: inline-block;
    background-color: #ed5c58;
    color: #fff;
    padding: 3px 5px;
    font-size: 13px;
    line-height: 1;
    content: '必須';
    position: absolute;
    right: 20px;
  }
  .icon {
    position: absolute;
    right: 30px;
    top: 30px;
  }
  @media (max-device-width: 767px) {
    .fl-form-line {
      display: block;
      border: none;
    }
    .form-label {
      display: block;
      background-color: #fff;
      width: 100%;
      padding: 0;
    }
    .fl-form {
      display: block;
      width: 100%;
      padding: 10px 0 0;
    }
    .icon {
      position: absolute;
      right: 12px;
      top: 22px;
    }
  }
`
interface Props {
  caption: string
  type: string
  name: string
  value: string
  require?: boolean
  placeholder?: string
  autoComplete?: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  minLength?: number
  children?: React.ReactNode
}

export const FormInput: React.FC<Props> = ({
  caption,
  type,
  name,
  value,
  require = false,
  placeholder = '',
  autoComplete = 'on',
  onChange,
  minLength,
  children,
}) => {
  return (
    <div className="fl-form-line">
      <label htmlFor={type} className={`form-label ${require && 'require'}`}>
        {caption}
      </label>
      <div className="fl-form" style={{ position: 'relative' }}>
        <input
          type={type}
          className="form-control peer"
          name={name}
          value={value}
          placeholder={placeholder}
          autoComplete={autoComplete}
          onChange={onChange}
          required
          minLength={minLength}
        />
        <span className="invisible peer-valid:visible icon">
          <Check color="green" />
        </span>
        {children}
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
